import React from "react";
import { DefaultSplash } from "./Default";
import { useFunnel } from "../../../context/FunnelContext";

export function GenderSplash({ config }) {
    const { state } = useFunnel();
    const gender = state.userData.gender;

    // Get content based on gender
    const content = {
        woman: {
            title: config.woman?.title || config.title,
            subtitle: config.woman?.subtitle || config.subtitle,
            imageUrl: config.woman?.imageUrl || config.imageUrl,
            buttonText: config.woman?.buttonText || config.buttonText,
        },
        man: {
            title: config.man?.title || config.title,
            subtitle: config.man?.subtitle || config.subtitle,
            imageUrl: config.man?.imageUrl || config.imageUrl,
            buttonText: config.man?.buttonText || config.buttonText,
        },
        default: {
            title: config.title,
            subtitle: config.subtitle,
            imageUrl: config.imageUrl,
            buttonText: config.buttonText,
        },
    };

    // Select content based on gender, fallback to default if gender is non-binary or not specified
    const displayContent = content[gender] || content.default;

    // Merge the display content with the original config
    const mergedConfig = {
        ...config,
        ...displayContent,
    };

    return <DefaultSplash config={mergedConfig} />;
}